export default __webpack_public_path__ + "static/media/Main-Page.9478717b.jpg";